import React, {Component} from 'react';
import {Route, Switch} from 'react-router-dom';

import Error404 from '../containers/Error404';
import SaleDash from '../containers/sales/SaleDash';
import SalesHistory from '../containers/sales/SalesHistory';
import Boxes from '../containers/sales/Boxes';
import BoxDetail from '../containers/sales/BoxDetail';
import OpenBoxDetail from "../containers/sale/OpenBoxDetail";
import Expenses from "../containers/expenses/Expenses";
import OutstandingBalances from "../containers/sales/OutstandingBalances";
import Tips from "../containers/sales/Tips";

class SalesRoute extends Component {

    render() {
        return (
            <div>
                {this.props.children}
                <Switch>
                    <Route exact path='/sales' component={SaleDash}/>
                    <Route exact path='/sales/history' component={SalesHistory}/>
                    <Route exact path='/sales/boxes' component={Boxes}/>
                    <Route exact path='/sales/tips' component={Tips}/>
                    <Route exact path='/sales/boxes/open/:id' component={OpenBoxDetail}/>
                    <Route exact path='/sales/boxes/:id/:code' component={BoxDetail}/>
                    <Route exact path='/sales/expenses' component={Expenses}/>
                    <Route exact path='/sales/balances' component={OutstandingBalances}/>
                    <Route exact path={'*'} component={Error404}/>
                </Switch>
            </div>
        );
    }
}

export default SalesRoute;



// WEBPACK FOOTER //
// ./src/routes/SalesRoute.js